define([], function() {
	return {
		changeModeAction: 'ChangeMode'
	};
});
